<template>
  <!-- 我是layout主界面 -->
  <div class="layout_div" :style="{background:$route.path=='/kisae/kisaeDetail'?'#044a8b':'#f0f2f5',height:'100%'}">
    <el-container style="height: 100%;">
      <el-aside :width="sideBarWidth" class="gpd_aside">
        <Sidebar @updated="updated" />
      </el-aside>
      <el-container>
        <el-header class="header">
          <div class="left">
            <div ref="operate" class="operate">
              <div class="isCollapse">
                <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
                  @click="$store.commit('changeCollapse')" />
              </div>
              <Navbar @remarkOpenPop="remarkOpen" @setUserPop="setUser" />
            </div>
          </div>
        </el-header>
        <el-main ref="main" v-if="flag">
          <slot></slot>
          <icp-link></icp-link>
        </el-main>
      </el-container>
    </el-container>

    <!--意见反馈--弹窗 -->
    <el-dialog :close-on-click-modal="false" :title="$t('company.Feedback')" :visible.sync="remarkPop" width="60%">
      <div style="padding-right: 60px;">
        <el-form ref="remarkPop" :model="form" :rules="formRules" label-position="right" label-width="180px">

          <el-form-item :label="$t('company.remark')" prop="content">
            <el-input v-model="form.content" :autosize="{ minRows: 4}" :placeholder="$t('warningSet.Pleaseenter')"
              type="textarea" />
          </el-form-item>
          <el-form-item :label="'上传图片'">
            <upload-imgs v-model="fileList"></upload-imgs>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="remarkPop = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitRemark('remarkPop')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!--用户设置--弹窗 -->
    <el-dialog :close-on-click-modal="false" :title="$t('tagInput.AccountSettings')" :visible.sync="setUserPop"
      class="setUserPop" width="80%">
      <el-form ref="setUserPop" label-position="right" label-width="180px" style="padding: 0 20px;">
        <el-row :gutter="40">
          <el-table :data="tableSetUserData" :show-header="false" style="width: 100%;">
            <el-table-column min-width="20%" prop="attr" style="font-weight: bold;" />
            <el-table-column min-width="60%" prop="content">
              <template slot-scope="scope">
                <div v-if="scope.row.key=='userPhone'" style="text-align: left;">
                  <span v-if="scope.row.content">{{ $t('tagInput.Tips2') }}</span>
                  <span style="color: #8BC34A;">{{ scope.row.content }}</span>
                  <span v-if="!scope.row.content">{{ $t('tagInput.Tips6') }}</span>
                </div>
                <div v-else-if="scope.row.key=='userEmail'" style="text-align: left;">
                  <div v-if="scope.row.content">
                    <span>{{ $t('tagInput.Tips4') }}</span>
                    <span style="color: #8BC34A;">{{ scope.row.content }}</span>
                    <span>{{ $t('tagInput.Tips5') }}</span>
                  </div>
                  <div v-else>
                    <span>{{ $t('tagInput.Tips3') }}</span>
                    <!-- <span>{{$t('tagInput.Tips5')}}</span> -->
                  </div>
                </div>
                <div v-else style="text-align: left;">
                  <span>{{ scope.row.content }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('yhubReport.Operating')" align="center" min-width="20%" prop>
              <template slot-scope="scope">
                <div v-if="scope.row.key!='userLoginName'&&scope.row.key!='lastLoginTime'" style="text-align: center;">
                  <div v-if="scope.row.content" style="display: inline-block;">
                    <i class="el-icon-circle-check" style="color: #8BC34A;" />
                    <span style="color: #8BC34A;">{{ $t('tagInput.seted') }}</span>
                    <span style="margin:0 10px;">|</span>
                    <el-link type="primary" @click="set(scope.row.key)">{{ $t('tagInput.modify') }}</el-link>
                  </div>
                  <div v-else style="display: inline-block;">
                    <i class="el-icon-warning-outline" style="color: #ff9800;" />
                    <span style="color: #ff9800;">{{ $t('tagInput.Notset') }}</span>
                    <span style="margin:0 10px;">|</span>
                    <el-link type="primary" @click="set(scope.row.key)">{{ $t('tagInput.set') }}</el-link>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 修改用户名、手机、邮箱--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="editUserInfoPop">
      <el-form ref="dataForm" :model="editUserObj" :rules="editUserRules" label-position="right" label-width="180px"
        style="width: 80%;max-width: 600px;margin-left: 50px;">
        <div v-if="editActive=='userRealName'">
          <el-form-item :label="$t('tagInput.nowName')">
            <el-input v-model="editUserObj.userRealName" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('tagInput.newName')">
            <el-input v-model="editUserObj.userRealNameNew" @input="change($event)" />
          </el-form-item>
        </div>
        <div v-if="editActive=='userPhone'">
          <el-form-item :label="$t('tagInput.nowPhone')">
            <el-input v-model="editUserObj.userPhone" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('tagInput.newphone')">
            <el-input v-model="editUserObj.userPhoneNew" @input="change($event)" />
          </el-form-item>
        </div>
        <div v-if="editActive=='userEmail'">
          <el-form-item :label="$t('tagInput.nowmail')">
            <el-input v-model="editUserObj.userEmail" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('tagInput.newmail')">
            <el-input v-model="editUserObj.userEmailNew" @input="change($event)" />
            <el-popover placement="top-end" title="" width="100%" trigger="hover" :content="$t('tagInput.someEmail')">
              <i slot="reference" class="el-icon-question"
                style="font-size:20px;position: absolute;top:8px;right: -25px;color: #858585;" />
            </el-popover>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="editUserInfoPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmEditUserPop('dataForm')">{{ $t('button.Confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改密码--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowEditPasswordPop">
      <el-form ref="editPassword" :model="editPasswordObj" :rules="editPassRules" label-position="right"
        label-width="180px" style="width: 70%;max-width: 600px;margin-left: 50px;">
        <el-form-item :label="$t('company.Name')" prop="userRealName">
          <el-input v-model="editPasswordObj.userRealName" :disabled="true" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.Account')" prop="userLoginName">
          <el-input v-model="editPasswordObj.userLoginName" :disabled="true" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.NewPassword')" prop="newPassward1">
          <el-input v-model="editPasswordObj.newPassward1" :placeholder="$t('company.enterNewPass')"
            @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.NewPassword')" prop="newPassward2">
          <el-input v-model="editPasswordObj.newPassward2" :placeholder="$t('company.enterNewPassAgain')"
            @input="change($event)" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowEditPasswordPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="editPasswordConfirmPop('editPassword')">
          {{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>

    <!-- drm体验提示 小广告 -->
    <drm-ad v-if="showDrmAd" />

    <!-- 升级提示弹窗 -->
    <el-dialog :title="$t('appUpdate.version_prompt')" :visible.sync="updateVisible" width="30%" >
      <p class="v_name">{{targetV}}</p>
      <div class="update_con" v-html="updateContent"></div>
      <span slot="footer" class="flex_center">
        <el-button type="primary" @click="confirmUp">{{$t('button.Confirm')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import { mapState } from 'vuex'
var Base64 = require('js-base64').Base64

import { userV3PageList, updateById, resetPassword, checkUpdate } from '@/api/index'
import { addCustomerService } from '@/api/feedBack'
import { getDateAndHour } from '@/utils/updateTime.js'
import { compareVersion } from '@/utils/index.js'
import config from '../../../package.json'

import DrmAd from '@/components/DrmAd.vue'
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar.vue'
import UploadImgs from '@/views/feedBack/components/UploadImgs.vue'
import IcpLink from '@/components/IcpLink.vue'
export default {
  name: 'Layout',
  components: {
    Sidebar,
    Navbar,
    DrmAd,
    UploadImgs,
    IcpLink
  },
  data () {
    return {
      flag: false,
      remarkPop: false,
      form: {
        content: ''
      },
      fileList: [
        'https://img.gpdcloud.net//service/21732095413053.jpg',
        'https://img.gpdcloud.net//service/11732095189059.jpg',
        'https://img.gpdcloud.net//service/11732095009559.jpg'
      ],

      userObj: {}, // 用户信息
      setUserPop: false,
      tableSetUserData: [],
      editUserInfoPop: false,
      editUserRules: {},
      editUserObj: {},
      editActive: null,
      isShowEditPasswordPop: false,
      editPassRules: {
        newPassward1: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        newPassward2: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      },
      editPasswordObj: {
        userRealName: '',
        userLoginName: '',
        newPassward1: '',
        newPassward2: ''
      },
      showDrmAd: false,
      version: config.version,
      updateVisible: false,
      updateContent: '',
      targetV: ''
    }
  },
  computed: {
    ...mapState(['isCollapse', 'company', 'userInfo']),
    sideBarWidth () {
      // 左侧菜单栏展开的宽度（el-aside）
      return this.isCollapse ? '64px' : '210px'
    },
    formRules () {
      return {
        content: { required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }
      }
    }
  },
  mounted () {
    console.log('layout-mounted')
    console.log(location)
    this.checkVersion()
    setTimeout(() => {
      this.showDrmAdHandle()
    }, 10000);

  },
  methods: {
    confirmUp () {
      this.updateVisible = false;
      location.reload()
    },
    // 检查版本，刷新操作
    checkVersion () {
      checkUpdate({
        appId: 'gpd_cloud',
        appName: 'GPD Cloud',
        appType: 3
      }).then(res => {
        console.log('版本信息：', res)
        if (res.resultCode == 1001) {
          const data = res.resultModel
          console.log(data.versionName, this.version)
          if (compareVersion(data.versionName, this.version) == 1) {
            console.log('待升级' + this.$i18n.locale, JSON.parse(data.remark))
            this.updateVisible = true;
            this.targetV = data.versionName

            let lang = this.$i18n.locale
            let str = JSON.parse(data.remark)[lang]
            str = str.replaceAll('\n', '<br/>')
            this.updateContent = str
          }
        }
      })
    },
    updated (bool) {
      this.flag = bool
    },
    getToday () {
      const time = new Date()
      const mon = time.getMonth() + 1
      const day = time.getDate()
      return mon + '/' + day
    },
    showDrmAdHandle () {
      const enable = this.$t('drmAd.enable') == 'true'
      console.log(enable)
      if (enable) {
        const url = location.href
        if (url.indexOf('gpdcloud') >= 0 || url.indexOf('local') >= 0) {
          const today = this.getToday()
          const adDate = localStorage.getItem('drm_trip_date')
          if (!adDate || (adDate && adDate != today)) {
            this.showDrmAd = true
          }
        }
      }
    },
    remarkOpen () {
      // 意见反馈弹窗--显示
      this.remarkPop = true
      for (var attr in this.remarkInfo) {
        this.remarkInfo[attr] = ''
      }
    },
    submitRemark (formName) {
      // 意见反馈弹窗--提交
      this.$refs[formName].validate(valid => {
        if (valid) {
          var param = {
            content: this.form.content,
            email: this.userInfo.userEmail,
            phoneNumber: this.userInfo.userPhone,
            source: 1,
            type: 2,
            "companyId": this.company.id,
            "companyName": this.company.companyName,
            // "createBy": '',
            // "createTime": 0,
            // "deviceType": "string",
            // "id": 0,
            "imgs": this.fileList.join(','),
            // "mcuId": "string",
            // "sn": "string",
            "sourceUrl": location.href,
            // "status": 0,
            // "updateTime": 0
          }
          addCustomerService(param).then(res => {
            if (res.resultCode == 1001) {
              this.$message({
                type: 'success',
                message: this.$t('warningSet.submitted')
              })
              this.remarkPop = false
            }
          })
        }
      })
    },

    setUser () {
      // 用户安全设置弹窗--显示
      this.setUserPop = true
      var param = {
        companyId: this.$store.state.companyId,
        pageNum: 1,
        pageSize: 10,
        userLoginName: this.userInfo.userLoginName,
        userRealName: ''
      }
      userV3PageList(param).then(res => {
        if (res.resultCode == 1001 && res.resultModel.list.length > 0) {
          this.tableSetUserData = []
          this.editUserObj = this.editPasswordObj = this.userObj = res.resultModel.list[0]
          this.tableSetUserData.push(
            { attr: this.$t('tagInput.LoginAccount'), key: 'userLoginName', content: this.userObj.userLoginName },
            { attr: this.$t('tagInput.Name'), key: 'userRealName', content: this.userObj.userRealName },
            { attr: this.$t('tagInput.loginPassword'), key: 'passWord', content: this.$t('tagInput.Tips1') },
            { attr: this.$t('tagInput.mobilephonenumber'), key: 'userPhone', content: this.userObj.userPhone },
            { attr: this.$t('tagInput.mailbox'), key: 'userEmail', content: this.userObj.userEmail },
            { attr: this.$t('tagInput.lastLoginTime'), key: 'lastLoginTime', content: getDateAndHour(new Date(this.userInfo.lastLoginTime).getTime(), 'noSecond') }
          )
        }
      })
    },
    set (key) {
      // 用户安全设置--更改账号等弹窗--显示
      this.editActive = key
      if (key == 'passWord') {
        this.isShowEditPasswordPop = true
      } else {
        this.editUserInfoPop = true
      }
    },
    confirmEditUserPop () {
      // 用户安全设置--更改账号等弹窗--提交
      var param = {
        clientId: '',
        companyId: this.$store.state.companyId,
        lang: '',
        notifyState: true,
        phoneType: '',
        secret: '',
        userEmail: this.userObj.userEmailNew || this.userObj.userEmail,
        userIdcard: '',
        userLoginName: this.userObj.userLoginName,
        userNickName: '',
        // 'userPassword': this.userObj.userPassword,
        userPhone: this.userObj.userPhoneNew || this.userObj.userPhone,
        userRealName: this.userObj.userRealNameNew || this.userObj.userRealName,
        id: this.userObj.id,
        userSalt: '',
        userSex: '',
        userState: ''
      }
      updateById(param).then(res => {
        if (res.resultCode == 1001) {
          this.editUserInfoPop = false
          this.setUser()
          this.$message({
            type: 'success',
            message: this.$t('warningSet.submitted')
          })
        } else if (res.resultCode == 201) {
          this.$message({
            type: 'error',
            message: res.resultMessage
          })
        }
      })
    },
    editPasswordConfirmPop (formName) {
      // 用户安全设置--更改密码弹窗--提交
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editPasswordObj.newPassward1 !== this.editPasswordObj.newPassward2) {
            this.$message({
              type: 'error',
              message: this.$t('company.mustSame') // '两次输入的密码必须相同'
            })
            return
          }
          var param = {
            password: Base64.encode(this.editPasswordObj.newPassward1),
            userLoginName: this.userObj.userLoginName
          }
          resetPassword(param).then(res => {
            if (res.resultCode == 1001) {
              this.$message({
                type: 'success',
                message: this.$t('warningSet.submitted')
              })
              this.isShowEditPasswordPop = false
            } else {
              this.$message({
                type: 'error',
                message: res.resultMessage
              })
            }
          })
        }
      })
    },
    change (e) {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.gpd_aside {
  background: $menuBg;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
}

.header {
  padding: 0;
  background: #fff;
  height: 52px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 6px 0px rgba(190, 204, 216, 0.4);
  border-bottom: 1px solid rgba(190, 204, 216, 0.4);
  z-index: 1;

  .left {
    height: 100%;
    width: 100%;

    .operate {
      display: flex;
      align-items: center;
      padding-left: 20px;
      height: 50px;
      color: #666;
      font-size: 16px;
      font-weight: 500;

      .isCollapse {
        cursor: pointer;
        margin-right: 10px;

        &:hover {
          color: #3963bc;
        }
      }

      .rotate {
        transform: rotate(180deg);
        transition: all 0.3s linear;
      }
    }
  }

  .right-info {
    display: flex;
    align-items: center;
  }
}

.backTop {
  position: fixed;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  right: 50px;
  bottom: 50px;
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 50%;
  z-index: 99;
  background: #fff;

  .iconfont {
    font-size: 36px;
  }
}

.sidenav-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
  display: none;
  cursor: pointer;

  &.show {
    display: block;
  }
}
.v_name {
  padding-bottom: 20px;
  text-align: center;
  font-size: 28px;
  color: $menuActiveText;
}
</style>
